/**
 * @file        src/api/siteSettings.js
 * @description Public read of the configured company/office address managed in
 *              the admin app. Backed by GET /api/v1/site-settings (single-row
 *              site_settings). One source of truth for invoices, vouchers, print
 *              modals and legal pages. Mirrors api/testimonials.js.
 * @author      Kinetika Labs
 * @created     2026-07-23
 * @changelog
 *   - 2026-07-23 Claude — Initial (shared company address for the customer site).
 */
import { get } from './client.js';

/** The configured company info (address, city, phone, …). Returns an object. */
export async function fetchCompanyInfo() {
  const data = await get('/site-settings');
  return data?.data || data || {};
}
